import { SlsCoreEventsClient } from '@serverlessinc/core-events'
import config from 'config';
import { session } from 'auth/session';

export const publishEvent = async (event) => {
  try {
    const slsCoreEventsClient = new SlsCoreEventsClient(
      config.platform.coreApiUrl,
      session.get('authIdToken'),
      'dashboard'
    )
    await slsCoreEventsClient.publish(event);
  } catch(error) {
    console.error('Failed to send page event', error);
  }
};
